export * from './RelativeTime';
export { default as RelativeTime } from './RelativeTime';
